/**
 * @file 公共工具
 */
import CallApp from 'callapp-lib';
import { Toast } from '@nutui/nutui';

/**
 * 是否ios
 */
export const equipmentType = () => { // 是否ios
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  return isiOS;
}

/**
 * 是否正式环境
 */
export const isPro = () => { // 是否正式环境
  return window.location.host === 'huituactivity.map.qq.com';
}

// 获取查询字符串指定key 
export const getSearchString = (key) => {
  // 获取URL中?之后的字符
  var str = location.search;
  str = str.substring(1,str.length);

  // 以&分隔字符串，获得类似name=xiaoli这样的元素数组
  var arr = str.split("&");
  var obj = new Object();

  // 将每一个数组元素以=分隔并赋给obj对象
  for(var i = 0; i < arr.length; i++) {
      var tmp_arr = arr[i].split("=");
      obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
  }
  return obj[key];
}

/**
 * 针对views文件夹 -- 操作查询字符串
 */
export const getSource = () => {
  const locationFromArr = window.location.search
    .substr(1)
    .split('&')
    .filter(item => {
      return item.indexOf('from') != -1;
    });
  return locationFromArr.length ? locationFromArr[0].split('=')[1] : null;
}

/**
 * 判断是否在2021年十月八号零点到2021年十月十三号零点
 */
export const timeNode = () => {
  // 1 活动前  2 活动中  3 活动后
  const myDateTime = new Date().getTime();
  const startTime = 1633622400000 //十月八号零点
  const endStart = 1634054400000 //十月十三号零点
  if (myDateTime < startTime) return 1;
  if (startTime <= myDateTime && myDateTime <= endStart) return 2;
  if (myDateTime > endStart) return 3;
}

/**
 * true 返回 年月日格式，false 返回 '-' 格式
 */
const add0 = (m) => { return m < 10 ? '0' + m : m }
export const toYYMMDDHMS = (date = new Date(), bool = false) => {
  const time = new Date(date);
  const y = time.getFullYear();
  const m = time.getMonth() + 1;
  const d = time.getDate();
  const h = time.getHours();
  const mm = time.getMinutes();
  const s = time.getSeconds();
  if(bool) 
  return y + '年' + m + '月' + d + '日 ' + add0(h) + ':' + add0(mm);
  else
  return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s);
};

/**
 * 手机物理返回键监听
 */
export const pushHistory = () => {
  // let state = { title: '', url: '' }
  window.history.pushState(null, null, document.URL)
}

/**
 * 获取当前时间 -- 将毫秒置为0
 */
export const getTime = (date = toYYMMDDHMS()) => {
  return Date.parse(new Date(date)) || Date.parse(new Date(date.replace(/-/g, '/')));
}



// data.nowTime = getTime();
// data.startTime = getTime(toYYMMDDHMS('2021-10-12 00:00:00'));
// data.endTime = getTime(toYYMMDDHMS('2021-10-14 00:00:00'));

/**
 * 判断是从什么端打开
 */
export const commonShare = (schemeUrl, beacon) => {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  const iswx = /micromessenger/i.test(navigator.userAgent); // 通过userAgent判断是否在微信内部浏览器
  let beaconData = {
    source: getSource(),
    status: timeNode() === 1 ? 'warm' : timeNode() === 2 ? 'going' : 'expire',
  };
  if (isiOS) {
    beaconData.platform = 'ios';
    beaconData.result = 'fail';
    beacon.onUserAction('activity_click', beaconData);
    Toast.text('企鹅汇图不支持苹果手机，请切换安卓系统使用');
    return;
  }

  if (iswx) {
    beaconData.platform = 'android';
    const WeixinJSBridge = window.WeixinJSBridge;
    WeixinJSBridge.invoke(
      'launchApplication',
      {
        // schemeUrl: 'htscheme://com.tencent.easyearn/activity?page_type=104' // 安卓使用android_path
        schemeUrl,
      },
      sRes => {
        if (sRes && sRes.err_msg.indexOf('launchApplication:ok') != -1) {
          // console.log('success');
          beaconData.install = '1';
          beaconData.result = 'success';
        } else {
          beaconData.install = '0'
          beaconData.result = 'fail';
          window.location.href = 'https://huitu.map.qq.com';
        }
        beacon.onUserAction('activity_click', beaconData);
       
      }
    );
    return;
  }
  const options = {
    scheme: {
      protocol: 'htscheme'
    },
    appstore: 'https://www.apple.com',
    fallback: 'https://huitu.map.qq.com',
    logFunc:(status)=>{
      if(status == 'pending'){
        beacon.onUserAction('activity_click', beaconData);
      }
      // console.log(status,'status',beaconData)
    },
    timeout: 2000
  };
  const callLib = new CallApp(options);
  const host = isPro() ? 'https://huituactivity.map.qq.com/' : 'https://huituactivitytest.map.qq.com/';
  callLib.open({
    // param: { page_type: 104, extra_params: {type:3,activityId:123,url:'https://huituactivity.map.qq.com/'} },
    param: { page_type: 104, extra_params: JSON.stringify({ type: 3, activityId: '5555', url: `${host}?from=${getSource()}`, time: new Date().getTime() })},
    path: 'com.tencent.easyearn/activity',
    callback: function() {
      window.location = 'https://huitu.map.qq.com'
      // self.$toast.fail('打开TestFlight失败,请先下载支持软件TestFlight');
      return false;
    }
  });
};